import { appLocalStorage } from '@/app/shared/commonURLs';

let HospitalStructureBaseURL = appLocalStorage.HospitalStructureURL;
let HospitalStructureBaseOdataURL = appLocalStorage.HospitalStructureOdataURL;
let HSMedcalSetupBaseURL = appLocalStorage.MedicalsetupUrl;

export class HSURL {
    constructor() {
         
        this.HospitalStructureServiceList = HospitalStructureURLs();
        this.HSMedicalSetupServiceList = HSMedicalSetupURLs();
    }
}

const HospitalStructureURL = new HSURL();

export { HospitalStructureURL };

function HospitalStructureURLs() {

    var services = {};

    //================ Assignments Types (Groups) Services ======================
    services["GetODataRoomZones"] = {
        Method: 'Get',
        URL: HospitalStructureBaseOdataURL + 'HospitalStructure_ZoneOData?'
    }

    services["AddZone"] = {
        Method: 'POST',
        URL: HospitalStructureBaseURL + 'HospitalStructure/AddZone',
    }

    services["EditZone"] = {
        Method: 'PUT',
        URL: HospitalStructureBaseURL + 'HospitalStructure/EditZone',
    }

    services["DeleteZone"] = {
        Method: 'DELETE',
        URL: HospitalStructureBaseURL + 'HospitalStructure/DeleteZone',
    }

    //================ Assignments Types (Groups) Services ======================


    services["GetActiveAssignmentTypes"] = {
        Method: 'Get',
        URL: HospitalStructureBaseOdataURL + 'AssignmentTypeOData?',
    }

    services["GetODataBuildingFloors"] = {
        Method: 'Get',
        URL: HospitalStructureBaseOdataURL + 'FloorsNameOData?'
    }

    services["GetActiveAssignmentTypesDDL"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'AssignmentType/GetActiveAssignmentTypesDDL',
    }

    services["GetActiveAssignmentTypesByMedicalState"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'AssignmentType/GetActiveAssignmentTypesByMedicalState',
    }
    
    services["AddAssignmentType"] = {
        Method: 'Post',
        URL: HospitalStructureBaseURL + 'AssignmentType/AddAssignmentType',
    }

    services["EditAssignmentType"] = {
        Method: 'Put',
        URL: HospitalStructureBaseURL + 'AssignmentType/EditAssignmentType',
    }

    services["DeleteAssignmentType"] = {
        Method: 'Put',
        URL: HospitalStructureBaseURL + 'AssignmentType/DeleteAssignmentType',
    }

    //================ Hospital Structure (Tree) Services ======================
    services["GetTreeData"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'HospitalStructure/GetTreeData',
    }

    //================ Hospital Structure Buildings ======================
    services["GetMaxFloorsCount"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'LKP_FloorsNames/GetFloorsNamesCount',
    }

    services["GetDefaultFloorsNames"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'LKP_FloorsNames/GetDefaultFloorsNames',
    }

    services["ValidateHSBuilding"] = {
        Method: 'Post',
        URL: HospitalStructureBaseURL + 'HospitalStructure/ValidateHSBuilding',
    }

    services["AddBuildingWithFloors"] = {
        Method: 'Post',
        URL: HospitalStructureBaseURL + 'HospitalStructure/AddBuildingWithFloors',
    }

    services["EditBuilding"] = {
        Method: 'Put',
        URL: HospitalStructureBaseURL + 'HospitalStructure/EditBuilding',
    }

    services["DeleteBuilding"] = {
        Method: 'Delete',
        URL: HospitalStructureBaseURL + 'HospitalStructure/DeleteBuilding',
    }
    services["GetAllBuldings"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'HospitalStructure/GetAllBuldings',
    }
    services["GetBuldings"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'HospitalStructure/GetBuldings',
    }
    services["GetBuilding"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'HospitalStructure/GetBuilding',
    }

    //================ Floors Services ======================
    services["GetFloorsByBuildingID"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'HospitalStructure/GetFloorsByBuildingID',
    }
    services["GetFloor"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'HospitalStructure/GetFloor'
    }

    services["AddFloor"] = {
        Method: 'Post',
        URL: HospitalStructureBaseURL + 'HospitalStructure/AddFloor'
    }

    services["EditFloor"] = {
        Method: 'Put',
        URL: HospitalStructureBaseURL + 'HospitalStructure/EditFloor'
    }

    services["DeleteFloor"] = {
        Method: 'DELETE',
        URL: HospitalStructureBaseURL + 'HospitalStructure/DeleteFloor',
    }

    //================ Rooms Services ======================
    services["GetFloorsRooms"] = {
        Method: 'Get',
        URL: HospitalStructureBaseOdataURL + 'HSRoomsOdata?'
    }

    services["getRoomsZonesView"] = {
        Method: 'Get',
        URL: HospitalStructureBaseOdataURL + 'HSZonesOdata?'
    }

    services["GetAllClassificationsDDL"] = {
        Method: 'Put',
        URL: HospitalStructureBaseURL + 'SLKP_AssignmentClassification/GetAllClassificationsDDL'
    }

    services["GetHospitalStructureSpecialitiesNames"] = {
        Method: 'Get',
        URL: HospitalStructureBaseOdataURL + 'HSSpecialitiesNamesOdata?'
    }

    //================ HS Beds Services ======================
    services["GetHospitalStructureBedsNames"] = {
        Method: 'Get',
        URL: HospitalStructureBaseOdataURL + 'HSBedsNamesOdata?'
    }

    services["GetRoomsByGroupDDL"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'HospitalStructure/GetRoomsByGroupDDL'
    }

    services["SaveRoom"] = {
        Method: 'POST',
        URL: HospitalStructureBaseURL + 'HospitalStructure/SaveRoom'
    }

    services["GetFloorRooms"] = {
        Method: 'Get',
        URL: HospitalStructureBaseURL + 'HospitalStructure/GetFloorRooms',
    }
    services["GetRoom"] = {
        Method: 'GET',
        URL: HospitalStructureBaseURL + 'HospitalStructure/GetRoom'
    }

    services["DeleteRoom"] = {
        Method: 'DELETE',
        URL: HospitalStructureBaseURL + 'HospitalStructure/DeleteRoom'
    } 

    return services;
}

function HSMedicalSetupURLs() {

    var services = {};

    services["GetAllSpecialitiesDDL"] = {
        Method: 'Get',
        URL: HSMedcalSetupBaseURL + 'Speciality/GetAllSpecialitiesDDL'
    }

    return services;
}